<app-kpi-widget
  [title]="'executiveStats.widgets.fuelConsumption' | transloco"
  [isLoading]="isLoading"
  [icon]="'ph-gas-pump'"
  [totalValue]="value"
  [totalCost]="cost"
  [costDifference]="difference"
  [percentageDifference]="percentageDifference"
  [dropdownOptions]="dropdownOptions"
  [isUptrendPositive]="isUptrendPositive"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [selectedDropdownValue]="selectedUnit"
  [valueFormatter]="formatValue.bind(this)"
  [costFormatter]="formatCost.bind(this)"
  [costDifferenceFormatter]="formatCostDifference.bind(this)"
  (dropdownChanged)="onDropdownChanged($event)"
  [isImageIcon]="false"
></app-kpi-widget>